import { mergeAttributes } from "@tiptap/core";
import { Heading } from "@tiptap/extension-heading";

export const CustomHeading = Heading.extend({
  renderHTML({ node, HTMLAttributes }) {
    const level = node.attrs.level;
    const classes = {
      2: "text-[18px] font-bold", // classe pour h2
      3: "text-[20px] font-bold uppercase", // classe pour h3
    };

    return [
      `h${level}`,
      mergeAttributes(this.options.HTMLAttributes, HTMLAttributes, {
        class: classes[level as keyof typeof classes] || "",
      }),
      0,
    ];
  },
});
